import axios from "axios";
import * as d3 from "d3";
import {axisTextDim1, colonAnnotation, inrFormatter, make_y_gridlines, responsivefy, XaxisAttribute} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("simplebar chart1:", url)
    console.log("Chart vizName called:", vizName)

    /* console.log("pm_right: ",chart.margin.right)
               console.log("pm_left: ", chart.margin.left)
               console.log("pm_top: ", chart.margin.top)
               console.log("pm_bottom: ",chart.margin.bottom)
               console.log("right_label: ",chart.rightLabelLength)
               console.log("left_label: ", chart.leftLabelLength)
               console.log("top_label: ", chart.topLabelLength)
               console.log("bottom_label: ",chart.bottomLabelLength)*/


    // set the ranges
    var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).padding(0.1);
    var y1Scale = d3.scaleLinear().rangeRound([chart.height, 0]);
    // define the axis
    var x1AxisLabel = d3.axisBottom().scale(x1Scale);
    var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter);

    // var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

    // d3.select("tooltip"+divId.id).remove(); // clear tooltip based on class of tip element
    // var y1tip = tooltip_class()

    // y1tip.attr('class', 'd3-tip'+divId.id)
    //    .html((d) =>{ return d.dim1_name+ colonAnnotation+ inrFormatter(d.metric1) })

    // Define 'div' for tooltips
    // var div = d3.select(divId)
    //     .append("div")  // declare the tooltip div
    //     .attr("class", "tooltip")              // apply the 'tooltip' class
    //     .style("opacity", 0);


    d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
    var div = d3.select(divId).append('div').attr('class', 'tooltip')
        .attr('style', 'position: absolute; opacity: 0;')
    /*   .attr('style','line-height', '1')
                    .attr('style','padding', '12px')
                    .attr('style','background', 'white')
                    .attr('style','border-radius', '15px')
                    .attr('style','border-width', '.5px')
                    .attr('style','border-style', 'groove');
               */
    // add the SVG element
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
        .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    if (gridflag == true) {
        // add the X gridlines
        /*  svg.append("g")
                         .attr("class", "grid")
                         .attr("transform", "translate(0," + chart.height + ")")
                         .call(make_x_gridlines(x1Scale)
                             .tickSize(-chart.height)
                             .tickFormat("") )*/

        // add the Y gridlines
        svg.append("g")
            .attr("class", "grid")
            .call(make_y_gridlines(y1Scale)
                .tickSize(-chart.width)
                .tickFormat(""))
    }
    //Calling tooltip
    // svg.call(tip1);

    // load the data
    axios.post(url, filterParam).then(res => {
        let data = res.data;

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        // scale range of the data
        x1Scale.domain(data.map((d) => {
            return d.dim1_name
        }));
        y1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })]);

        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            //.attr("class","axisL20")
            .style('font-size', axisLabelFontSize)
            .style("text-anchor", "start")
            .attr("dx", XaxisAttribute)
            .attr("dy", "-.55em")
            .attr("transform", "rotate(-50)")
            .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            //.style('fill', 'blue')
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 2)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        // Add bar chart
        svg.selectAll("bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("x", (d) => {
                return x1Scale(d.dim1_name)
            })
            .attr("width", x1Scale.bandwidth())
            .attr("y", function (d) {
                return y1Scale(d.metric1)
            })
            .style("fill", (d) => {
                return d.dim3_name
            })
            .attr("height", (d) => {
                return chart.height - y1Scale(d.metric1)
            })
            // .on('mouseover', y1tip.show)
            // .on('mouseout', y1tip.hide)
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(
                    d.dim1_name + colonAnnotation + inrFormatter(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            // .on("mouseover", function() {
            //     div.transition()
            //         .style("opacity", 1);
            // })
            .on("mouseout", function () {
                div.transition()
                    .style("opacity", 0);
            });

        //Add value top of the bar
        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', (d) => {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2
            })
            .attr('y', (d) => {
                return y1Scale(d.metric1) - 5
            })
            .text((d) => {
                return inrFormatter(d.metric1)
            })
            .attr('fill', 'black')
            .style('font-size', '30px')
    });
}
